import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';

import { IonicModule } from '@ionic/angular';
import { TranslateModule } from '@ngx-translate/core';

import { ChipsModule } from '../chips/chips.module';

import { RecommendationsListComponent } from './components/recommendations-list/recommendations-list.component';
import { ArticleRecommendationCardComponent } from './components/article-recommendation-card/article-recommendation-card.component';
import { IconComponent } from '../icon/icon.component';

@NgModule({
  imports: [
    CommonModule,
    IonicModule,
    TranslateModule,
    ChipsModule,
    IconComponent
  ],
  exports: [
    RecommendationsListComponent
  ],
  declarations: [
    RecommendationsListComponent,
    ArticleRecommendationCardComponent
  ]
})
export class RecommendationsModule {
}
